export default __webpack_public_path__ + "static/media/tooltip-close-icon.ac2cea64.svg";